import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateCell',
})
export class TranslateCellPipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(value: string, prefix = ''): string {
    if (!value) return '';
    return this.translate.instant(prefix + value);
  }
}
